var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconRotateLeft = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeWidth: "2.167", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { transform: "translate(0.448 -2.17)" },
                React.createElement("path", { strokeDasharray: "4,4", d: "M6.4,20.4c1.8,5.1,7.4,7.7,12.4,5.9c3.2-1.1,5.5-3.8,6.3-7" })),
            React.createElement("g", { transform: "translate(0.448 -2.17)" },
                React.createElement("path", { d: "M3.7,8.5V15h6.5" }),
                React.createElement("path", { d: "M25.1,19.3c1.2-5.3-2.1-10.5-7.3-11.7c-3.3-0.7-6.7,0.2-9.1,2.6l-5,4.7" })))));
});
export default IconRotateLeft;
//# sourceMappingURL=IconRotateLeft.js.map